import * as PoolAddActions from '../actions/poolAddEdit'

const initialState = {
  isSaving: false,
  isLoading: false,
  error: '',
}

export default (state = initialState, action) => {
  switch (action.type) {

  case PoolAddActions.POOLADDEDIT_REQUESTED:
    return {
      ...state,
      isSaving: true
    }

  case PoolAddActions.POOLADDEDIT_COMPLETED:
    return {
      ...state,
      isSaving: false
    }

  case PoolAddActions.POOLADDEDIT_ERROR:
    return {
      ...state,
      isSaving: false,
      error: action.data
    }

  default:
    return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/poolAddEdit.js